import { createFileRoute } from '@tanstack/react-router';
import { JourneysAnonymousHandoff } from '@/pages/workspaces/anonymous/routing';
import { AppBundle } from '@/utils/app-bundles';
import { LastWorkspaceResolver } from './-components';

/**
 * The legacy `/journeys/anonymous` URL, which forwards to the Hydra list. The resolver belongs
 * here: this URL keeps the `journeys` segment, so a `/workspaces/last` sentinel resolves against
 * the embedded app's bundle before the forward builds its target.
 */
function JourneysAnonymousIndexRoute() {
  return (
    <LastWorkspaceResolver appBundle={AppBundle.Journeys}>
      <JourneysAnonymousHandoff />
    </LastWorkspaceResolver>
  );
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/journeys/anonymous/')({
  component: JourneysAnonymousIndexRoute,
});
